import { authActions, authSelectors } from '@virtus/common/auth/reducer';
import { applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { queryMiddlewareAdvanced } from 'redux-query/advanced';
import createSagaMiddleware from 'redux-saga';
import config from 'src/config';
import createNetworkInterface from 'src/coreservices/reduxQueryNetworkInterface';
import rootReducer, { RootState } from 'src/reducers/rootReducer';
import { runAllSagas } from 'src/sagas/rootSaga';

export const getQueries = (state: RootState) => state.queries;
export const getEntities = (state: RootState) => state.entities;

let store: Store;

/** setup saga and return store ready for <Provider /> */
export const initStore = () => {  
  // let networkConfig = {};
  // if(config.useAD){
  //   networkConfig = {...config.aad}
  //   networkConfig.useAD = true;
  // }
  // else{
  //   networkConfig = {...config.idp};
  //   networkConfig.useIDP = false;
  // }  
  const getUsername = () => authSelectors.getUsername(store.getState());  
  const sagaMiddleware = createSagaMiddleware();
  const reduxQueryMiddleware = queryMiddlewareAdvanced(
    createNetworkInterface({
      ...config,   
      //...networkConfig,     
      onUnauthorized: () => store.dispatch(authActions.unauthorized()),
      getUsername,
    }),
  )(getQueries, getEntities);
  const middleware = [reduxQueryMiddleware, sagaMiddleware];
  store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middleware)));
  runAllSagas(sagaMiddleware);
  return store;
};
